import React from "react";

export default ({ width = 16, height = 16, fill = "#18A0FB", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66797 8.00033C6.66797 7.26395 7.26492 6.66699 8.0013 6.66699C8.73768 6.66699 9.33464 7.26395 9.33464 8.00033C9.33464 8.73671 8.73768 9.33366 8.0013 9.33366C7.26492 9.33366 6.66797 8.73671 6.66797 8.00033Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66797 3.33333C6.66797 2.59695 7.26492 2 8.0013 2C8.73768 2 9.33464 2.59695 9.33464 3.33333C9.33464 4.06971 8.73768 4.66667 8.0013 4.66667C7.26492 4.66667 6.66797 4.06971 6.66797 3.33333Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66797 12.6663C6.66797 11.93 7.26492 11.333 8.0013 11.333C8.73768 11.333 9.33464 11.93 9.33464 12.6663C9.33464 13.4027 8.73768 13.9997 8.0013 13.9997C7.26492 13.9997 6.66797 13.4027 6.66797 12.6663Z"
        fill={fill}
      />
    </svg>
  );
};
